import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { ServiceModalPayload } from '@/services/ModalService/types';
import { Modals } from '../enums/Modals';

type ModalState = {
  [key in Modals]?: any;
};

const initialState: ModalState = {};

export const serviceModalSlice = createSlice({
  name: 'serviceModal',
  initialState,
  reducers: {
    addModal: (
      state,
      {
        payload: { name, payload, closeOthers },
      }: PayloadAction<{ name: Modals; payload: ServiceModalPayload; closeOthers?: boolean }>,
    ) => {
      if (!state[name]) {
        if (closeOthers) {
          Object.keys(Modals).forEach((modalKey) => {
            if (modalKey !== name) delete state[modalKey];
          });
        }
        state[name] = payload;
      }
    },
    closeModal: (state, { payload }: PayloadAction<Modals>) => {
      if (state[payload]) {
        delete state[payload];
      }
    },
    replaceModalPayload: (
      state,
      { payload: { name, payload } }: PayloadAction<{ name: Modals; payload: ServiceModalPayload }>,
    ) => {
      if (state[name]) {
        state[name] = payload;
      }
    },
    updateModalPayload: (
      state,
      { payload: { name, payload } }: PayloadAction<{ name: Modals; payload: ServiceModalPayload }>,
    ) => {
      if (state[name]) {
        state[name] = {
          ...state[name],
          ...payload,
        };
      }
    },
    closeAllModals: () => initialState,
  },
});

export const { addModal, closeModal, updateModalPayload, replaceModalPayload, closeAllModals } =
  serviceModalSlice.actions;

export const serviceModalReducerPath = serviceModalSlice.reducerPath;
export const serviceModalReducer = serviceModalSlice.reducer;
